export default {
    url: '/department',
    template: '<user-group-list-department/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/list/department/index.js